import useWebSocket from 'react-use-websocket'

// Custom hook to manage WebSocket connection
export const useLabWebSocket = (taskId) => {
  // Construct WebSocket URL based on taskId
  // const wsUrl = taskId
  //   ? `${
  //       window.location.protocol === 'https:' ? 'wss' : 'ws'
  //     }://api-gw-staging.poridhi.io/api/v1/tasks/${taskId}/status`
  //   : null
  const wsUrl = taskId
    ? `${
        window.location.protocol === 'https:' ? 'wss' : 'ws'
      }://api-gateway.poridhi.io/api/v1/tasks/${taskId}/status`
    : null

  // Get the access token from localStorage
  const accessToken = localStorage.getItem('access_token')

  // Options for the WebSocket connection
  const options = {
    shouldReconnect: () => true,
    reconnectInterval: 3000,
    protocols: [accessToken],
  }

  return useWebSocket(wsUrl, options)
}
